import {fromUtcTimeFormat} from "../../../shared/utils/dayjsUtil";

const parseLogData = (logString, record) => {
    if (!record.parsedLogData) {
        try {
            record.parsedLogData = JSON.parse(logString);
        } catch (error) {
            console.error('logString 파싱 오류:', error);
            record.parsedLogData = {};
        }
    }
    return record.parsedLogData;
};

export const getEventTruckLogColumns = () => {
    return [
        {
            title: '로그 타입',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).logType,
            filterMultiple: false,
            filters: [
                {text: 'Open_TruckEvent', value: 'Open_TruckEvent'},
                {text: 'Expire_TruckEvent', value: 'Expire_TruckEvent'},
                {text: 'Clear_TruckEvent', value: 'Clear_TruckEvent'},
            ],
            onFilter: (value, record) => parseLogData(record.logString, record).logType === value,
        },
        {
            title: '이벤트 ID',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).eventID,
        },
        {
            title: '라운드 ID',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).roundID,
        },
        {
            title: '획득 아이템',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).itemInfo,
            width: '30%',
        },
        {
            title: '트리거 시간',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {triggerTime} = parseLogData(logString, record);
                return triggerTime ? fromUtcTimeFormat(triggerTime) : '';
            },
        },
        {
            title: '만료 시간',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {expiredTime} = parseLogData(logString, record);
                return expiredTime ? fromUtcTimeFormat(expiredTime) : '';
            },
        },
    ];
};